// Third party
import React from 'react';
import classNames from 'classnames';

// Components
import { Button } from '../../../components/buttons';
import { ContactPastille } from '../../../components/misc';
import { Tooltip } from '../../../components/tooltips';

// Utils
import { formatMessage, FormattedMessage } from '../../../../utils/i18n';
import ComparisonContact from '@/types/comparison-contact';

type Props = {
  onClick?: () => void;
  contact: ComparisonContact;
  contactName: string;
  withText?: boolean;
  className?: string;
  isLightVersion?: boolean;
};

const ComparisonTopBarContactButton = ({ onClick, contact, contactName, className, isLightVersion }: Props) => {
  let comparisonContact = contact;

  if (!contact.fname && !contact.lname && contact.fullName) {
    const nameWords = contactName.split(' ');
    comparisonContact = {
      ...contact,
      fname: nameWords[0] || '',
      lname: nameWords[1] || '',
    };
  }

  return (
    <Tooltip
      className={classNames({ 'custom-tooltip-v2': isLightVersion })}
      message={formatMessage('Comparison.PreparedFor', { name: contactName })}
      data-private
      data-dd-privacy="mask"
      place="bottom"
    >
      <Button
        aria-label={formatMessage('Comparison.ClickToContact', { name: contactName })}
        onClick={onClick}
        dark
        noBackground
        className={classNames(className, 'comparison-top-bar-contact-button top-bar-button')}
        role="link"
      >
        <ContactPastille contact={comparisonContact} />
        <FormattedMessage id="Comparison.Contact" />
      </Button>
    </Tooltip>
  );
};

export default ComparisonTopBarContactButton;
